// What the assistant panel says while one of this module's tools is running
// («Buscando entre las máquinas…»), in the four languages.
//
// A contract with `backend/assistant.js`, like the analytics vocabulary is with
// `backend/analytics.js`: every tool registered there gets the key
// `assistant.tools.<registered name>` — the name the platform gives it, with the
// module in front — and this file holds that key. The English here is the
// same sentence as the tool's `label`, which is what the panel shows when a
// key is missing. platform/web/tests/assistantToolLabels.test.js checks both:
// a tool without its four sentences, or an English one that drifted from the
// backend label, fails the suite.

const toolLabels = {
  es: {
    sop_find_sop_plans: 'Buscando entre los planes S&OP',
    sop_sop_plan_summary: 'Leyendo el plan S&OP',
    sop_sop_capacity_gaps: 'Mirando dónde se queda corta la planta',
    sop_sop_risks: 'Leyendo los riesgos del S&OP',
    sop_sop_scenario_comparison: 'Comparando los escenarios del S&OP',
    sop_record_sop_decision: 'Apuntando la decisión',
  },
  ca: {
    sop_find_sop_plans: 'Cercant entre els plans S&OP',
    sop_sop_plan_summary: 'Llegint el pla S&OP',
    sop_sop_capacity_gaps: 'Mirant on es queda curta la planta',
    sop_sop_risks: 'Llegint els riscos de l’S&OP',
    sop_sop_scenario_comparison: 'Comparant els escenaris de l’S&OP',
    sop_record_sop_decision: 'Anotant la decisió',
  },
  en: {
    sop_find_sop_plans: 'Looking through the S&OP plans',
    sop_sop_plan_summary: 'Reading the S&OP plan',
    sop_sop_capacity_gaps: 'Checking where the plant runs out',
    sop_sop_risks: 'Reading the S&OP risks',
    sop_sop_scenario_comparison: 'Comparing the S&OP scenarios',
    sop_record_sop_decision: 'Writing down the decision',
  },
  fr: {
    sop_find_sop_plans: 'Recherche parmi les plans S&OP',
    sop_sop_plan_summary: 'Lecture du plan S&OP',
    sop_sop_capacity_gaps: 'Où l’usine manque de capacité',
    sop_sop_risks: 'Lecture des risques du S&OP',
    sop_sop_scenario_comparison: 'Comparaison des scénarios du S&OP',
    sop_record_sop_decision: 'Enregistrement de la décision',
  },
}

/** The module's catalogue with its tool labels hung from `assistant.tools`, locale by locale. */
export function withToolLabels(base) {
  const merged = {}
  for (const [locale, catalogue] of Object.entries(base)) {
    merged[locale] = {
      ...catalogue,
      assistant: {
        ...catalogue.assistant,
        tools: { ...catalogue.assistant?.tools, ...toolLabels[locale] },
      },
    }
  }
  return merged
}

export default toolLabels
